/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { AccessRequestApprovalType } from './AccessRequestApprovalType';
import {
    AccessRequestApprovalTypeFromJSON,
    AccessRequestApprovalTypeFromJSONTyped,
    AccessRequestApprovalTypeToJSON,
    AccessRequestApprovalTypeToJSONTyped,
} from './AccessRequestApprovalType';

/**
 * 
 * @export
 * @interface RoleCreateRequest
 */
export interface RoleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleCreateRequest
     */
    canBeRequestedByUsers?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleCreateRequest
     */
    isGlobal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleCreateRequest
     */
    permissionIds?: Array<any> | null;
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    tags?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof RoleCreateRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleCreateRequest
     */
    organizationGroupIds?: Array<any> | null;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof RoleCreateRequest
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof RoleCreateRequest
     */
    requireUserOrganizationInMinSide?: boolean | null;
    /**
     * 
     * @type {AccessRequestApprovalType}
     * @memberof RoleCreateRequest
     */
    accessRequestApprovalType?: AccessRequestApprovalType;
    /**
     * 
     * @type {boolean}
     * @memberof RoleCreateRequest
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleCreateRequest
     */
    allowEndUserCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleCreateRequest
     */
    allowEndUserAssignment?: boolean;
    /**
     * 
     * @type {any}
     * @memberof RoleCreateRequest
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleCreateRequest
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    helpTextReasonField?: string | null;
}



/**
 * Check if a given object implements the RoleCreateRequest interface.
 */
export function instanceOfRoleCreateRequest(value: object): value is RoleCreateRequest {
    return true;
}

export function RoleCreateRequestFromJSON(json: any): RoleCreateRequest {
    return RoleCreateRequestFromJSONTyped(json, false);
}

export function RoleCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'canBeRequestedByUsers': json['canBeRequestedByUsers'] == null ? undefined : json['canBeRequestedByUsers'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'tags': json['tags'] === undefined ? undefined : json['tags'] === null ? null : json['tags'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'organizationGroupIds': json['organizationGroupIds'] === undefined ? undefined : json['organizationGroupIds'] === null ? null : json['organizationGroupIds'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] === undefined ? undefined : json['requireUserOrganizationInMinSide'] === null ? null : json['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': json['accessRequestApprovalType'] == null ? undefined : AccessRequestApprovalTypeFromJSON(json['accessRequestApprovalType']),
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'allowEndUserCreation': json['allowEndUserCreation'] == null ? undefined : json['allowEndUserCreation'],
        'allowEndUserAssignment': json['allowEndUserAssignment'] == null ? undefined : json['allowEndUserAssignment'],
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
    };
}

export function RoleCreateRequestToJSON(json: any): RoleCreateRequest {
    return RoleCreateRequestToJSONTyped(json, false);
}

export function RoleCreateRequestToJSONTyped(value?: RoleCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'canBeRequestedByUsers': value['canBeRequestedByUsers'],
        'description': value['description'],
        'isGlobal': value['isGlobal'],
        'name': value['name'],
        'permissionIds': value['permissionIds'],
        'shortName': value['shortName'],
        'tags': value['tags'],
        'userType': UserTypeToJSON(value['userType']),
        'organizationGroupIds': value['organizationGroupIds'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': AccessRequestApprovalTypeToJSON(value['accessRequestApprovalType']),
        'requiresMfa': value['requiresMfa'],
        'allowEndUserCreation': value['allowEndUserCreation'],
        'allowEndUserAssignment': value['allowEndUserAssignment'],
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
    };
}

